// extracted by mini-css-extract-plugin
module.exports = {"initiativeCardDetailsList":"InitiativeCardDetailsList_initiativeCardDetailsList__1xxza"};